import backgroundFull from '../../../../festival-assets/background-full.png';
import elementTwo from '../../../../festival-assets/element-2.png';
import logoCircle from '../../../../festival-assets/logo-circle.svg';
import logoHorizontal from '../../../../festival-assets/logo-horizontal.svg';
import logoVertical from '../../../../festival-assets/logo-vertical.svg';
import airhorn from '../../../../festival-assets/airhorn.mp3';
import flightOfBumblebee from '../../../../festival-assets/flight-of-bumblebee.mp3';

export const FESTIVAL_ASSETS = {
  backgroundFull,
  elementTwo,
  logoCircle,
  logoHorizontal,
  logoVertical,
  airhorn,
  flightOfBumblebee,
} as const;
